import React from 'react';
import styled, { css } from 'styled-components';
import ImportedScalarValuesTable from './ImportedScalarValuesTable';
import type { ImportedOutcomeReason, ImportedScalarValue, TagIconProps } from './types';
import WorkflowAndEvaluationCells from './WorkflowAndEvaluationCells';
import { Table } from './StyledTable';

export type ImportedDataProps = {
  importedOutcomeReasons: ImportedOutcomeReason[];
  importedMatrixModels: ImportedScalarValue[];
  importedOutputAttributes: ImportedScalarValue[];
};

const Container = styled.div`
  padding: 24px;
`;

const OutcomeReasonName = styled.span`
  color: #757575;
`;

const TagIcon = styled.i<TagIconProps>`
  border-radius: 4px;
  margin-right: 15px;
  padding: 2px;
  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor}
  `}
`;

const ImportedData = ({
  importedOutcomeReasons,
  importedMatrixModels,
  importedOutputAttributes,
}: ImportedDataProps) => {
  const showOutcomeReasons = importedOutcomeReasons && importedOutcomeReasons.length > 0;
  const showOutputAttributes = importedOutputAttributes && importedOutputAttributes.length > 0;
  const showMatrixModels = importedMatrixModels && importedMatrixModels.length > 0;

  return (
    <Container>
      {showOutcomeReasons && (
        <Table>
          <tr>
            <th>Outcome Reason</th>
            <th>Workflow</th>
            <th>Evaluation</th>
          </tr>
          {importedOutcomeReasons.map(({
            color,
            evaluation_token: evaluationToken,
            name,
            workflow_name: workflowName,
            workflow_token: workflowToken,
            workflow_version: workflowVersion,
          }) => (
            <tr key={`imported_outcome_reason_table_row_${name}`}>
              <td>
                <TagIcon backgroundColor={`#${color}`} className="far fa-fw fa-sign-in" />
                <OutcomeReasonName>{name}</OutcomeReasonName>
              </td>
              <WorkflowAndEvaluationCells
                workflowName={workflowName}
                evaluationToken={evaluationToken}
                workflowToken={workflowToken}
                workflowVersion={workflowVersion}
              />
            </tr>
          ))}
        </Table>
      )}
      {showOutcomeReasons && (showOutputAttributes || showMatrixModels) && (<hr />)}
      {showOutputAttributes && (
        <ImportedScalarValuesTable
          type="imported_output_attribute"
          scalarValues={importedOutputAttributes}
        />
      )}
      {showOutputAttributes && showMatrixModels && (<hr />)}
      {showMatrixModels && (
        <ImportedScalarValuesTable
          type="imported_matrix_model"
          scalarValues={importedMatrixModels}
        />
      )}
    </Container>
  );
};

export default ImportedData;
